module.exports = __webpack_public_path__ + "img/termineur_CPG_017.ab7b4d3a.jpg";